import React from 'react'
import IconSVG from 'svg-inline-react'
import { List } from 'immutable'
import { Link } from 'react-router'
import { pluralize } from 'humanize-plus'
import LoadingDots from 'components/shared/LoadingDots'
import cx from 'classnames'

import Oxford from 'components/shared/Oxford'
import { ConditionType, ConditionTypes, OperatorToDisplay } from 'app/modules/playbook/constants'
import RepAvatarPreview from './RepAvatarPreview'

import closeIconSrc from '!svg-inline?removeTags=true!images/svg/close.svg'
import pencilIconSrc from '!svg-inline!images/svg/pencil.svg'

import './style.styl'

const standardPreview = (conditionValues, getValueDisplay) => {
  return (
    <Oxford
      items={conditionValues
        .map(getValueDisplay)
        .map(x => (!!x ? <strong>{x}</strong> : '""'))
        .toJS()}
      limit={2}
      conjunction="or"
    />
  )
}

const TeamPreview = ({ teams, teamIds }) => {
  const items = teamIds
    .map(teamId => teams.find(t => t.id === teamId))
    .map(team => (!!team ? <strong>{team.name}</strong> : ''))
    .toJS()
  return <Oxford items={items} limit={3} conjunction="or" />
}

const EmailPlaybookPreview = ({
  getPlaybookIdForCampaignId,
  getIsPlaybookIdForCampaignIdLoading,
  playbooks,
  value,
}) => {
  try {
    const campaignId = parseInt(value.first().split('=')[1])
    const isLoading = getIsPlaybookIdForCampaignIdLoading(campaignId)
    if (isLoading)
      return (
        <span>
          <LoadingDots />
        </span>
      )

    const playbook = playbooks.get(`${getPlaybookIdForCampaignId(campaignId)}`)
    return (
      <div>
        Came to website from email in{' '}
        <Link to={`/reports/playbooks/${playbook.get('id')}`} target="_blank">
          {playbook.get('name')}
        </Link>
      </div>
    )
  } catch(err) {
    // TODO: we don't have the campaign yet, it's being fetched
    return null
  }
}

const ConditionPreview = ({
  teams,
  playbooks,
  condition: { field, operator, value },
  onDeleteClick,
  onEditClick,
  getSegmentNames,
  getPlaybookIdForCampaignId,
  getIsPlaybookIdForCampaignIdLoading,
  isOutboundPlaybook,
  isOutboundSessionCondition,
  isEmailPlaybookCondition,
  isTeamCondition,
  isSegment,
  isOnFreePlan,
}) => {
  const { displayName, getValueDisplay = x => `${x}` } = ConditionTypes.get(field)
  const conditionValues = _.get(value, 'join', false) ? value : List.of(value)
  const displayStaticOutboundCondition = isOutboundPlaybook && isOutboundSessionCondition
  return (
    <div className={cx("playbook-condition-preview flex-space-between", {
      'playbook-condition-preview-disabled': isOnFreePlan || displayStaticOutboundCondition
    })}>
      {displayStaticOutboundCondition && (
        <div>Clicked a link to your website from a <b>Drift Sequence</b>, an <b>Outreach Sequence</b>, a <b>Salesloft Cadence</b>, or an email sent with the <b>Drift Extension</b>.</div>
      )}
      {isSegment && (
        <div className="playbook-condition-preview-content">
          <div>{displayName}&nbsp;</div>
          <div>{standardPreview(getSegmentNames(conditionValues), getValueDisplay)}</div>
        </div>
      )}
      {isEmailPlaybookCondition && (
        <div className="playbook-condition-preview-content">
          <EmailPlaybookPreview
            getPlaybookIdForCampaignId={getPlaybookIdForCampaignId}
            playbooks={playbooks}
            getIsPlaybookIdForCampaignIdLoading={getIsPlaybookIdForCampaignIdLoading}
            value={value}
          />
        </div>
      )}
      {isTeamCondition && (
        <div className="playbook-condition-preview-content">
          <div>
            {pluralize(conditionValues.size, 'Team')} <TeamPreview teams={teams} teamIds={conditionValues} />{' '}
            {conditionValues.size > 1
              ? OperatorToDisplay[operator].replace('is', 'are')
              : OperatorToDisplay[operator]}
          </div>
        </div>
      )}
      {!isEmailPlaybookCondition &&
        !isTeamCondition &&
        !isSegment &&
        !displayStaticOutboundCondition && (
          <div className="playbook-condition-preview-content">
            <div>
              {displayName}&nbsp;
              {OperatorToDisplay[operator]}&nbsp;
            </div>
            <div>
              {field === ConditionType.OUTBOUND_REP ? (
                <RepAvatarPreview listOfSelectedIds={conditionValues} />
              ) : (
                standardPreview(conditionValues, getValueDisplay)
              )}
            </div>
          </div>
        )}
      {!isOnFreePlan && !displayStaticOutboundCondition &&
        <div className="flex">
          <IconSVG className="playbook-condition-preview-icon" onClick={onEditClick} src={pencilIconSrc} />
          <IconSVG className="playbook-condition-preview-icon" onClick={onDeleteClick} src={closeIconSrc} />
        </div>
      }
    </div>
  )
}

export default ConditionPreview



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/ConditionPreview/component.js